import gsap from "gsap";

const initLang = () => {
  const toggle = () => document.querySelector(".js-lang-toggle");

  const generateTimeline = () => {
    const response = gsap.timeline({
      paused: true,
      ease: "power4",
    });

    response.add("open");

    response.from(
      ".js-lang-list",
      {
        yPercent: 50,
      },
      "open"
    );

    response.to(
      ".js-lang-list",
      {
        display: "block",
        opacity: 1,
      },
      "open"
    );

    response.to(
      ".js-lang-icon",
      {
        scaleY: -1,
        duration: 0.2,
      },
      "open"
    );

    return response;
  };

  const handleClick = () => {
    if (timeline.time() !== 0) {
      return timeline.reverse();
    }

    return timeline.play();
  };

  const timeline = generateTimeline();

  toggle()?.addEventListener("click", handleClick);
};

export default initLang();
